/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRequestDto } from '../../models/create-request-dto';
import { CreateShipmentResponse } from '../../models/create-shipment-response';

export interface BrtControllerCreate$Params {
  
    /**
     * Shipment data
     */
    body: CreateRequestDto
}

export function brtControllerCreate(http: HttpClient, rootUrl: string, params: BrtControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateShipmentResponse>> {
  const rb = new RequestBuilder(rootUrl, brtControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateShipmentResponse>;
    })
  );
}

brtControllerCreate.PATH = '/couriers/brt/create-shipment';
